import { useParams } from "react-router";
import { DetectedMetersTable } from "@/components/media-transmitters/detected-meters-table";

export function DetectedMetersPage() {
	const { sn } = useParams<{ sn: string }>();
	if (!sn) return null;
	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<DetectedMetersTable sn={sn} />
		</div>
	);
}
